import { createElement } from '@gn-audio/core/common/templating';
import './basket-email-sender.component.scss';
import template from './basket-email-sender.component.html';
var BasketEmailSenderComponent = /** @class */ (function () {
    function BasketEmailSenderComponent() {
        var _this = this;
        this.validate = function () {
            var regex = new RegExp("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,4}$" /* ValidationRule.Email */, 'gi');
            return regex.test(_this.input.value);
        };
        this.handleInput = function (event) {
            switch (event.key) {
                case "Enter" /* KeyboardCode.Enter */:
                    _this.onSend(event);
                    break;
                default:
                    break;
            }
        };
        this.onSend = function (event) {
            if (!_this.validate()) {
                event.preventDefault();
                return;
            }
            if (_this.onSubmit) {
                _this.onSubmit(_this.input.value);
            }
        };
    }
    BasketEmailSenderComponent.prototype.render = function (_a) {
        var container = _a.container, translations = _a.translations, onSubmit = _a.onSubmit;
        this.onSubmit = onSubmit;
        this.element = createElement(template, {}, translations);
        container.appendChild(this.element);
        this.input = this.element.querySelector('.basket-email-sender__input');
        this.input.addEventListener('keydown', this.handleInput);
        this.button = this.element.querySelector('.basket-email-sender__button');
        this.button.addEventListener('click', this.onSend);
    };
    BasketEmailSenderComponent.prototype.destroy = function () {
        var _a, _b, _c;
        (_a = this.input) === null || _a === void 0 ? void 0 : _a.removeEventListener('keydown', this.handleInput);
        (_b = this.button) === null || _b === void 0 ? void 0 : _b.removeEventListener('click', this.onSend);
        (_c = this.element) === null || _c === void 0 ? void 0 : _c.remove();
    };
    BasketEmailSenderComponent.prototype.hide = function () {
        this.element.classList.add("hidden" /* CssClass.Hidden */);
    };
    BasketEmailSenderComponent.prototype.reset = function () {
        this.element.classList.remove("hidden" /* CssClass.Hidden */);
        this.input.value = '';
    };
    return BasketEmailSenderComponent;
}());
export { BasketEmailSenderComponent };
